import api, { API_URL } from './api'
import axios from 'axios'

const API_BASE_URL =API_URL

export const authService = {
  // Authentication
  login: (credentials) => api.post('/auth/login', credentials),
  register: (userData) => api.post('/auth/register', userData),
  logout: () => api.post('/auth/logout'),
  refreshToken: (refreshToken) => {
    // Use a separate axios instance without interceptors for refresh requests
    // to avoid infinite loops
    return axios.post(`${API_BASE_URL}/auth/refresh`, { refreshToken }, {
      headers: {
        'Content-Type': 'application/json',
      },
      timeout: 30000
    });
  },
  
  // Password management
  forgotPassword: (email) => api.post('/auth/forgot-password', { email }),
  resetPassword: (token, password) => api.post('/auth/reset-password', { token, password }),
  changePassword: (currentPassword, newPassword) => 
    api.post('/auth/change-password', { 
      current_password: currentPassword, 
      new_password: newPassword 
    }),
  
  // Email verification
  verifyEmail: (token) => api.post('/auth/verify-email', { token }),
  
  // User info
  getCurrentUser: () => api.get('/auth/me'),
}